import React, { Component } from 'react';
import ReceivedPaymentFormEnhancer from './ReceivedPaymentFormEnhancer';
import { Prompt, withRouter } from 'react-router-dom';
import moment from 'moment';
import { restRequest, checkError, getOrganizationDate } from '../../Helpers';
import { Loader } from '../../Components';
import '../../Components/Form/CustomerPaymentForm/CP.css';
import '../../Components/Table/Table.css';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';

class RecivedPaymentForm extends Component {
  type = this.props.type || 'add';

  id = this.props.id || null;
  // contactId = window.location.search.split('=')[1] || null;
  state = {
    loading: true,
    salesOrder: {
      contactId: null,
      salesOrderNo: '',
      reference: '',
      customerNotes: '',
      termsAndConditions: '',
      items: [],
    },
    paymentDate: moment(getOrganizationDate()),
    selectedPaymentMethod: null,
    total_received_full_amount: 0,
    globalCurrency: null,
    currency_list: [],
    customerList: [],
    paymentMethods: [],
    invoiceList: [],
    paymentId: null,
    contactId: null,
    payment_mode: '',
    payment_mode_name: '',
    amount_received: null,
    organizationCurrency: {},
    showPrompt: false,
    advancePaymentId: null,
    customerNotes: '',
    reference: '',
    refund_amount: 0,
    contactObj: {},
    exchange_rate: 1,
    disable_currency_change: false,
  };

  componentDidMount() {
    document.title =
      this.props.type === 'add'
        ? t('Payments.title')
        : t('update_customer_payment');
    this.fetchData();
    sessionStorage.setItem('once', false);
    sessionStorage.setItem('fullscreen', false);
    window.onbeforeunload = function () {
      return true;
    };
  }

  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  fetchData = async () => {
    this.setState({ loading: true });
    const { type } = this;

    switch (type) {
      case 'edit':
        await this.fetchCreateCustomerPaymentEdit();
        break;
      case 'add':
      default:
        await this.fetchCreateCustomerPayment();
        break;
    }

    this.setState({ loading: false });
  };

  // getCloneEditUrl(id, type) {
  //   return `salesorders/${id}/${type === 'edit' ? 'edit' : 'clone'}`;
  // }

  fetchCreateCustomerPayment() {
    return restRequest('get', `advancepayment/invoice/create`)
      .then((res) => {
        let [paymentMode = {}] = res?.payment_methods || [];
        let currency;

        // Check if base_currency is an array
        if (Array.isArray(res?.base_currency)) {
          currency = res.base_currency.find(
            (cur) => cur?.id === res?.organization_base_currency_id
          );
        } else {
          // If it's a single object
          currency = res.base_currency; // or just assign directly
        }
        // const currency = res?.base_currency.find((cur) => cur?.id === res?.organization_base_currency_id)
        // console.log(currency, "currency")
        this.setState({
          organizationCurrency: res.base_currency.find(
            (currency) => currency.is_base_currency === true
          ),
          currency_list: res.base_currency.map((currency) => ({
            ...currency,
            value: currency.id,
            label: `${currency.currency_code} - ${currency.symbol} - ${
              currency.name
            } ${currency.is_base_currency ? '(Base Currency)' : ''}`,
          })),
          paymentMethods: res.payment_methods,
          invoiceList: res.invoices,
          paymentId: res.payment_no,
          disabled: res.disabled,
          customerList: res.customer_list,
          selectedPaymentMethod: res.payment_methods[0],
          payment_mode: paymentMode?.id || '',
          payment_mode_name: paymentMode?.name || '',
          globalCurrency: res.base_currency.find(
            (currency) => currency.is_base_currency === true
          )?.id,
        });
      })
      .catch((error) => checkError(error));
  }

  fetchCreateCustomerPaymentEdit() {
    return restRequest('get', `advancepayment/${this.id}/edit`)
      .then((res) => {
        let paymentMode = res?.payment_methods.find(
          (pay) => pay.name === res.advance_payment.payment_mode
        );

        this.setState({
          organizationCurrency: res.base_currency.find(
            (currency) => currency.is_base_currency === true
          ),
          // currency_list: res.base_currency.map((currency) => ({
          //   ...currency,
          //   value: currency.id,
          //   label: currency.name,
          // })),
          currency_list: res.base_currency.map((currency) => ({
            ...currency,
            value: currency.id,
            label: `${currency.currency_code} - ${currency.symbol} - ${
              currency.name
            } ${currency.is_base_currency ? '(Base Currency)' : ''}`,
          })),
          paymentMethods: res.payment_methods,
          invoiceList: res?.invoices,
          paymentId: res.payment_no,
          disabled: res.disabled,
          customerList: res.customer_list,
          contactId: res.advance_payment.customer_id,
          amount_received:
            res.advance_payment?.exchanged_payment /
              res.advance_payment.exchange_rate || 1,
          // res.advance_payment.exchange_rate || 1,
          refund_amount: res.advance_payment.refund_amount,
          advancePaymentId: res?.advance_payment.id,
          customerNotes: res?.advance_payment?.note || '',
          reference: res?.advance_payment?.reference || '',
          selectedPaymentMethod: res.payment_methods[0],
          payment_mode: paymentMode?.id,
          payment_mode_name: paymentMode?.name,
          paymentDate: moment(res?.advance_payment?.payment_date),
          exchangeRate: res.advance_payment.exchange_rate || 1,

          contactObj: {
            label: res?.customer_list[0]?.display_name,
            value: res?.customer_list[0]?.id,
          },
          globalCurrency: res?.advance_payment?.currency_id,
          total_received_full_amount: res?.received_full_amount,
          disable_currency_change: res.disable_currency_change,

          //
          // organizationCurrency,
          // paymentMethods,
          // invoiceList,
          // paymentId,
          // customerList,
          // contactId,
          // amount_received: payment.toString(),
          // advancePaymentId,
          // selectedPaymentMethod: paymentMethods[0],
          // payment_mode,
          // payment_mode_name,
        });
      })
      .catch((error) => checkError(error));
  }

  submitRequestType = () => {
    if (this.type === 'edit') {
      return 'put';
    }
    return 'post';
  };

  submitRequestUrl = () => {
    switch (this.type) {
      case 'edit':
        return `advancepayment/${this.state.advancePaymentId}/update`;
      case 'add':
      default:
        return 'advancepayment/invoice';
    }
  };

  successMessage = () => {
    switch (this.type) {
      case 'edit':
        this.props.handleToast(t('common.payment_updated'), 'success');
        break;
      case 'add':
      default:
        this.props.handleToast(
          t('common.payment_created_successfully'),
          'success'
        );
    }
  };

  updateCustomerList = (newCustomer) => {
    this.setState((state) => ({
      customerList: [newCustomer, ...state.customerList],
    }));
  };

  handlePrompt = (status = true) => this.setState({ showPrompt: status });

  renderSalesOrderForm() {
    const { handleToast, history } = this.props;
    let {
      salesOrder,
      customerList,
      organizationCurrency,
      currency_list,
      paymentMethods,
      invoiceList,
      payment_mode,
      payment_mode_name,
      paymentId,
      paymentDate,
      amount_received,
      refund_amount,
      disable_currency_change,
      contactId,
      advancePaymentId,
      customerNotes,
      reference,
      contactObj,
      globalCurrency,
      exchangeRate,
      total_received_full_amount,
    } = this.state;
    return (
      <>
        <Prompt
          when={this.state.showPrompt}
          message={t('common.leave_page_warning')}
        />
        <ReceivedPaymentFormEnhancer
          type={this.type}
          salesOrder={{ ...salesOrder }}
          customerList={customerList}
          paymentMethods={paymentMethods}
          t={this.props.t}
          disabled={this.state.disabled}
          invoiceList={invoiceList}
          organizationCurrency={organizationCurrency}
          currency_list={currency_list}
          submitRequestType={this.submitRequestType}
          submitRequestUrl={this.submitRequestUrl}
          successMessage={this.successMessage}
          history={history}
          paymentDate={paymentDate}
          handleToast={handleToast}
          setPrompt={this.handlePrompt}
          payment_mode={payment_mode}
          payment_mode_name={payment_mode_name}
          _payment_mode={payment_mode_name}
          paymentId={paymentId}
          amount_received={amount_received}
          refund_amount={refund_amount}
          updateCustomerList={this.updateCustomerList}
          contactId={contactId}
          advancePaymentId={advancePaymentId}
          customerNotes={customerNotes}
          reference={reference}
          contactObj={contactObj}
          disable_currency_change={disable_currency_change}
          globalCurrency={globalCurrency}
          exchangeRate={exchangeRate}
          total_received_full_amount={total_received_full_amount}
        />
      </>
    );
  }

  render() {
    console.log('invoiceList', this.state.invoiceList);
    if (this.state.loading) return <Loader />;
    return this.renderSalesOrderForm();
  }
}

export default withRouter(withTranslation()(RecivedPaymentForm));
